<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">
          Listado de super clientes &nbsp;&nbsp;&nbsp;
          <i class="text-success fas fa-users fa-2x"></i>
        </h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'cat-superclientes-nuevo', params: {} }"
              >
                <i class="fa fa-plus"></i>
                Nuevo super cliente
              </router-link>
              <a class href="#"></a>
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refresh</a
              >
            </div>
            <div class="col-sm-6">
              <form
                @submit="filterData"
                action="#"
                class="form-inline justify-content-sm-end"
              >
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="submit">
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table table-hover">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-lightborder">
            <thead>
              <tr>
                <th>Codigó</th>
                <th>NIT</th>
                <th>Nombre</th>
                <th>Dirección</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>{{ current.codigo }}</td>
                <td>{{ current.nit }}</td>
                <td>{{ current.nombre }}</td>
                <td>{{ current.direccion }}</td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ClienteService from "@/services/catalogos/ClienteService";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: 1,
      data: [],
    };
  },
  mounted() {
    this.refreshData();
  },
  methods: {
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "cat-superclientes-editar",
          params: { nit: current.codigo },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-superclientes-editar",
          params: { nit: current.codigo },
        });
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    filterData(e) {
      e.preventDefault();
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    clearFilterData() {
      this.searchtext = "";
      this.filterActivo = null;
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
        activo: this.filterActivo,
      });
    },
    hide: function () {
      this.$data.destroy();
    },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "super-cliente", params).then((res) => {
        self.data = res.data;
      });
    },
    showModalEdit() {},
  },
};
</script>
